import apiService from './apiService';

class ForumService {
  async getCategories() {
    return apiService.get('/forum/categories');
  }

  async getThreads(params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== '') query.append(k, v); });
    return apiService.get(`/forum/threads?${query.toString()}`);
  }

  async getThread(id) {
    return apiService.get(`/forum/threads/${id}`);
  }

  async createThread(data) {
    return apiService.post('/forum/threads', data);
  }

  async updateThread(id, data) {
    return apiService.put(`/forum/threads/${id}`, data);
  }

  async deleteThread(id) {
    return apiService.delete(`/forum/threads/${id}`);
  }

  async pinThread(id) {
    return apiService.post(`/forum/threads/${id}/pin`);
  }

  async lockThread(id) {
    return apiService.post(`/forum/threads/${id}/lock`);
  }

  async hideThread(id) {
    return apiService.post(`/forum/threads/${id}/hide`);
  }

  async getReplies(threadId, params = {}) {
    const query = new URLSearchParams(params).toString();
    return apiService.get(`/forum/threads/${threadId}/replies?${query}`);
  }

  async createReply(threadId, data) {
    return apiService.post(`/forum/threads/${threadId}/replies`, data);
  }

  async updateReply(id, data) {
    return apiService.put(`/forum/replies/${id}`, data);
  }

  async deleteReply(id) {
    return apiService.delete(`/forum/replies/${id}`);
  }

  async hideReply(id) {
    return apiService.post(`/forum/replies/${id}/hide`);
  }

  async markExpertAnswer(id) {
    return apiService.post(`/forum/replies/${id}/expert`);
  }

  async toggleReaction(data) {
    return apiService.post('/forum/react', data);
  }

  async report(data) {
    return apiService.post('/forum/report', data);
  }

  async getReports(params = {}) {
    const query = new URLSearchParams(params).toString();
    return apiService.get(`/forum/reports?${query}`);
  }

  async updateReportStatus(id, status) {
    return apiService.put(`/forum/reports/${id}/status`, { status });
  }

  async createCategory(data) {
    return apiService.post('/forum/categories', data);
  }

  async updateCategory(id, data) {
    return apiService.put(`/forum/categories/${id}`, data);
  }

  async moveThread(id, categoryId) {
    return apiService.post(`/forum/threads/${id}/move`, { categoryId });
  }
}

export default new ForumService();
